module.exports = __webpack_public_path__ + "static/media/headermobile.94c7be79.jpg";